import { PhonebookTypes } from '../../../../core/api/models';
import { Directive, ElementRef, Input, OnInit } from '@angular/core';



@Directive({
  selector: '[phoneBookTypeStyle]',
  standalone: true
})
export class PhonebookTypeDirective implements OnInit {

  @Input('phoneBookTypeStyle') type: PhonebookTypes;

  constructor(private element: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }


  getCssClassList(): string {

    let classList = "tw-font-medium badge ";

    switch (this.type) {
      case PhonebookTypes.Private:
        classList += 'badge-light-slate';
        break;
      case PhonebookTypes.Public:
        classList += 'badge-light-blue';
        break;
      case PhonebookTypes.ParentPublic:
        classList += 'badge-light-info';
        break;

      default:
        break;
    }
    return classList;
  }





}

